module.exports = __webpack_public_path__ + "logo.351b82e64e2edd717984.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 382
// module chunks = 8